import { PotParent } from "./potParent";

export class RightPot extends PotParent {
  constructor(scene, value, table) {
    super(scene, value, table, "green-chips", "green-chip");
    this.scene = scene;
    this.table = table;
    this.value = value;
    this.timer = null;
  }
  handleGameState(state) {
    if (state.sidePots[2] && state.sidePots[2].value) {
      this.setWinPotTweenDelay();
      if (this.scene.tweenEnable) {
        this.timer = this.scene.time.addEvent({
          delay: this.winPotTweenDelay, // ms
          callback: () => {
            if (this.table.gameState.sidePots[2]) {
              this.visibilityControls(
                this.table.gameState.sidePots[2].value !== 0
              );
              this.changeText(this.table.gameState.sidePots[2].value);
            }
            this.timer.remove();
          },
          callbackScope: this,
        });
        this.table.poolArray.push(this.timer);
      } else {
        this.changeText(state.sidePots[2].value);
        this.visibilityControls(true);
      }
    } else this.visibilityControls(false);
  }
  handleVisibilityChange(hidden) {
    super.handleVisibilityChange(hidden);
    if (this.timer) this.timer.remove();
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    super.positionControls(width, height, initX, initY);

    this.chips.setPosition(initX + width * .556, initY + height * .315);

    this.chip.setPosition(this.chips.x, this.chips.y);

    // this.createWinChips();

    this.text.setPosition(
      this.chips.x + (this.chips.displayWidth - this.text.width) / 2,
      this.chips.y + (this.chips.displayHeight)
    );

    // this.textBox.setPosition(
    //   this.chips.x + this.chips.displayWidth,
    //   this.text.y + (this.text.height - this.textBox.displayHeight) / 2
    // );
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    super.reposition(width, height, initX, initY);

    this.chips.setPosition(initX + width * .556, initY + height * .315);

    this.chip.setPosition(this.chips.x, this.chips.y);

    // this.createWinChips();

    this.text.setPosition(
      this.chips.x + (this.chips.displayWidth - this.text.width) / 2,
      this.chips.y + (this.chips.displayHeight)
    );

    // this.textBox.setPosition(
    //   this.chips.x + this.chips.displayWidth,
    //   this.text.y + (this.text.height - this.textBox.displayHeight) / 2
    // );
  }
  remove() {
    this.removeParent();
  }
}
